import { Injectable } from "@angular/core";
import { McticHttpClient } from "@mctic/ng-core";
import { Observable } from "rxjs";
import { ConfiguracaoAnoBase, Identity } from "..";
import { ConfiguracaoAnoBaseVO } from "../shared/model/configuracao-ano-base-vo.model";

@Injectable({
  providedIn: 'root'
})

export class ConfiguracaoParametrizacaoService {

  configuracaoAnoBaseSelecionada: ConfiguracaoAnoBase;
  configuracaoAnoBaseVO: ConfiguracaoAnoBaseVO;

  private readonly endpoint = '/sepin-backend/rest/configuracoes-ano-base';

  constructor(private readonly http: McticHttpClient) {
  }



  obterConfiguracaoAnoBasePorTipo(idTipoConfiguracao: number): Observable<ConfiguracaoAnoBase> {
    return this.http.get<ConfiguracaoAnoBase>(`${this.endpoint}/tipo/${idTipoConfiguracao}`);
  }

  salvar(configuracaoAnoBaseVO: ConfiguracaoAnoBaseVO): Observable<Identity<number>> {
    return this.http.post<Identity<number>>(this.endpoint, configuracaoAnoBaseVO);
  }

}
